<template>
  <s-app>
    <router-view />
    <div class="absolute bottom-0 z-[9999] w-full">
      <v-alert
        v-if="thereAreAlerts"
        :type="alerts[0].type"
        :text="alerts[0].message"
        class="absolute !flex-none"
        closable
        @click:close="alerts.shift()"
      />
    </div>
    <v-snackbar v-model="isVisible" location="bottom right">
      {{ message }}
      <template #actions>
        <v-btn icon="mdi-close" variant="text" @click="closeSnackbar" />
      </template>
    </v-snackbar>
  </s-app>
</template>

<script setup lang="ts">
import { SApp } from 'sima-suite-components-vue3'
import '@/assets/tailwind.css'
import '@/assets/fonts/fonts.css'
import { computed, watch } from 'vue'
import { useAlerts } from './composables/alerts'
import { useSnackbar } from './composables/snackbar'
import { useCompanies } from '@/plugins/companySelection/companies'

const { alerts } = useAlerts()
const { isVisible, message, closeSnackbar } = useSnackbar()

const thereAreAlerts = computed(() => {
  return alerts.value.length > 0
})

const { selectedCompany } = useCompanies()

watch(
  selectedCompany,
  (company) => {
    if (company) {
      document.title = `Workspace | ${company.initials} | SIMA`
    } else {
      document.title = 'Workspace | SIMA'
    }
  },
  { immediate: true }
)
</script>

<style>
@import 'sima-suite-components-vue3/dist/style.css';
@import 'sima-suite-components-vue3/dist/icons.css';
</style>
